import React, { useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Descriptions, theme } from "antd"

import { Drawer } from "@components/Page"
import { readOperation } from "@components/Store/BackstageStore/useCampaignsStore"
import { EMAIL_DRAWER_WIDTH } from "@components"
import { Value, EmailPreview } from "@components/Text"
import { useRequest as useEffect } from "@components/AppContext"

const LABEL_TO = "To"
const LABEL_FROM = "From"
const LABEL_SENT = "Sent At"
const LABEL_CAMPAIGN_DELETED = "Related campaign was deleted."


const NotificationDrawer = ({ drawer }) => {
  const [ html, setHtml ] = useState('')
  const [ notification, setNotification ] = useState()
  const [ isDeletedCampaign, setIsDeletedCampaign ] = useState(false)

  useEffect(request => {
    if (!notification) {
      return
    }

    const {
      body,
      html: messageHtml
    } = notification.emailMessage

    const isCampaign = !messageHtml

    if (!isCampaign) {
      setHtml(messageHtml)
      return
    }

    const isJson = body.startsWith('json:')

    if (!isJson) {
      setHtml(body)
      return
    }

    const [ , bodyJson ] = body.split('json:')

    const parameters = JSON.parse(bodyJson)

    const { campaignId } = parameters

    request(readOperation, { id: campaignId }, ['DocumentNotFoundError'])
      .then(({ data }) => setHtml(data.html))
      .catch(() => setIsDeletedCampaign(true))
  }, [ notification ])

  const items = useMemo(() => !notification
    ? []
    : [
        {
          key: 'toAddress',
          label: LABEL_TO,
          children: notification.emailMessage.toAddress,
        },
        {
          key: 'fromAddress',
          label: LABEL_FROM,
          children: notification.emailMessage.fromAddress,
        },
        ...(
          !notification.sentAt
            ? []
            : [
              {
                key: 'sentAt',
                label: LABEL_SENT,
                children: <Value value={notification.sentAt} />,
              }
            ]
        ),
      ]
  , [ notification ])

  const title = useMemo(() => (
    notification
      ? notification.emailMessage.subject
      : ""
  ), [ notification ])

  const onClose = () => {
    setHtml('')
    setNotification()
    setIsDeletedCampaign(false)
  }

  const drawerProps = {
    width: EMAIL_DRAWER_WIDTH,
    onOpen: setNotification,
    styles: { body: { margin: 0, padding: 0 } },
    destroyOnClose: true,
    title,
    drawer,
    onClose,
  }

  const { token } = theme.useToken()
  const backgroundColor = '#fafafa'
  const { colorSplit, paddingLG } = token

  const preview = isDeletedCampaign
    ? LABEL_CAMPAIGN_DELETED
    : (
        <EmailPreview
          html={html}
          style={{ padding: 0 }}
        />
      )

  return (
    <Drawer {...drawerProps}>
      <div
        style={{
          borderBottom: `1px solid ${colorSplit}`,
          padding: paddingLG,
          backgroundColor,
        }}
      >
        <Descriptions
          size="small"
          items={items}
          column={1}
          bordered={false}
        />
      </div>

      {preview}
    </Drawer>
  )
}

NotificationDrawer.propTypes = {
  drawer: PropTypes.shape().isRequired,
}

export default NotificationDrawer
